import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

const LeftContentLayout = ({ layoutClassName, className, children }) => {
  const styles = cn(
    'flex flex-col ml-4 divide-y divide-solid divide-gray-400',
    className,
    layoutClassName || 'desktop:w-4/6',
  );
  return <div className={styles}>{children}</div>;
};

LeftContentLayout.propTypes = {
  layoutClassName: PropTypes.string,
  className: PropTypes.string,
};

LeftContentLayout.defaultProps = {
  layoutClassName: '',
  className: '',
};

export default LeftContentLayout;
